/*
 * AddStudent Messages
 *
 * This contains all the text for the AddStudent component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    assignTeacher: {
        id: 'app.components.assignedTeacherInfo.assignTeacher',
        defaultMessage: 'Assign teacher'
    }
});



// WEBPACK FOOTER //
// ./app/components/assigned-teacher-info/messages.js